import Icon from '../../components/Icon.vue'

Icon.register({"regular/copy":{"width":448,"height":512,"paths":[{"d":"M433.9 65.9L382.1 14.1A48-48 0 0 1 348.1 0H176C149.5 0 128 21.5 128 48V96H48C21.5 96 0 117.5 0 144V464C0 490.5 21.5 512 48 512H272C298.5 512 320 490.5 320 464V416H400C426.5 416 448 394.5 448 368V99.9A48-48 0 0 1 433.9 65.9zM266 464H54A6-6 0 0 0 48 458V150A6-6 0 0 0 54 144H128V368C128 394.5 149.5 416 176 416H272V458A6-6 0 0 0 266 464zM394 368H182A6-6 0 0 0 176 362V54A6-6 0 0 0 182 48H288V136C288 149.3 298.7 160 312 160H400V362A6-6 0 0 0 394 368zM400 112H336V48H345.6C347.2 48 348.7 48.6 349.9 49.8L398.2 98.1A6-6 0 0 0 400 102.4V112z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/regular/copy.js
// module id = null
// module chunks = 